import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class MaintenanceService {
    static isInMaintenanceMode(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('pcmaintenance'),
            'checkMaintenanceMode',
            [],
            additionalHeaders
        );
    }
}
